import type { SelectOption } from '~/components/form/FormSelect.vue';
import type { CreateSelectValue } from '~/types';

export const getEnumDropdownValues = (t: any, enumObj: any, translationKey: string): SelectOption[] => {
    const keys = Object.values(enumObj);

    const values = keys.map(key => ({
        value: key,
        label: t(`${translationKey}.${key}`),
    }));

    values.sort((a, b) => a.label.localeCompare(b.label));

    return values;
};

export const getEnumCreateSelectValues = (t: any, enumObj: any, translationKey: string): CreateSelectValue[] => {
    const keys = Object.values(enumObj);

    const values = keys.map(key => ({
        id: key as string,
        text: t(`${translationKey}.${key}`),
    }));

    values.sort((a, b) => a.text.localeCompare(b.text));

    return values;
};
